






















































import { Component, Vue, Watch, Prop} from 'vue-property-decorator';
import { JobDetailsModule } from '@/store/modules/jobDetails';
import GiganautVue from '@/components/Shared/GiganautVue';
import JobWorkerDto from '@/models/JobWorkers/JobWorkerDto';
import JobWorker from '@/components/JobWorkers/JobWorker.vue'
import JobWorkerStatus from '@/components/JobWorkers/Display/JobWorkerStatus.vue'
import JobWorkerStatusEnum from '@/models/JobWorkers/JobWorkerStatus';
import JobInterestedWorkersSendToContact from '@/components/JobWorkers/JobInterestedWorkersSendToContact.vue';

@Component({
  name: 'JobInterestedWorkers',
  components: { JobWorker, JobWorkerStatus, JobInterestedWorkersSendToContact }
})
export default class extends GiganautVue {

	jobWorkerStatusEnum = JobWorkerStatusEnum;
	page = 1;
	perPage = 8;

	get selectedJobWorker() {
		return JobDetailsModule.jobWorkersVM.selectedInterestedJobWorker;
	}

	set selectedJobWorker(value: JobWorkerDto) {
		JobDetailsModule.jobWorkersVM.selectedWorkerId = value.workerId;
		JobDetailsModule.jobWorkersVM.selectedInterestedJobWorker = value;
	}
	get currentJob() {
		return JobDetailsModule.currentJob;
	}
	
	get jobWorkers() {
		return JobDetailsModule.jobWorkersVM.jobWorkers;
	}

	get pagedJobWorkers() {
		return this.interestedWorkers.slice((this.page - 1)* this.perPage, this.page* this.perPage)
	}

	get interestedWorkers() {
		return this.jobWorkers.filter((jobWorker) => (
			jobWorker.status === JobWorkerStatusEnum.WorkerInterested ||
			jobWorker.status === JobWorkerStatusEnum.ContactInterested ||
			jobWorker.status === JobWorkerStatusEnum.SentToContact
			))
	}
	
	async onPageChanged(input: number){
		JobDetailsModule.jobWorkersVM.selectedInterestedJobWorker = (this.pagedJobWorkers[0]);
	}

	get loadingWorkers() {
		return JobDetailsModule.loadingWorkers;
	}

}
